import React from "react";

export function StepHeader({ step, title }: { step: number; title: string }) {
    return (
        <div className="flex items-center gap-3 mb-3">
            <span className="flex items-center justify-center w-7 h-7 rounded-full bg-dark-green text-white text-sm font-bold shrink-0">
                {step}
            </span>
            <h3 className="text-base font-semibold text-off-black">{title}</h3>
        </div>
    );
}
